import { AppThunk } from '../states/generateStore';
import { 
  suiteCrmUrl,
  getDaikinProduct,
  getPEAdmin
} from './constants';

import shellSlice from '../states/shell/slice';
import snackBarSlice from '../states/snackbar/slice';

const onLoadProductData = (): AppThunk =>
async (dispatch, getStore) => {
  try {
    // Get PE Admin
    let responsePEAdmin = await fetch(suiteCrmUrl.concat(getPEAdmin),
      {
        method: 'GET',
      }
    );
    let resultPEAdmin = await responsePEAdmin.json();

    if (resultPEAdmin) {
      dispatch(shellSlice.actions.updatePEAdmin(resultPEAdmin));
    } else {
      // show warning
      dispatch(snackBarSlice.actions.updateAlert({message: "Can not get Bonus product data from Server", severity: "warning"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }

    // get product data
    let responsePrd = await fetch(suiteCrmUrl.concat(getDaikinProduct),
      { 
        method: 'GET',
      }
    );
    let resultPrd = await responsePrd.json();
    if (resultPrd) {
      // Update isLoaded
      dispatch(shellSlice.actions.updateIsLoaded(true));
      dispatch(shellSlice.actions.updateProductData(resultPrd));
    } else {
      // show warning
      dispatch(snackBarSlice.actions.updateAlert({message: "Can not get product data from Server", severity: "warning"}));
      dispatch(snackBarSlice.actions.updateSnackBar(true));
    }
  } catch (err) {
    console.log(err);
    // show error
    dispatch(snackBarSlice.actions.updateAlert({message: "onLoadProductData: Can not get data from Server", severity: "error"}));
    dispatch(snackBarSlice.actions.updateSnackBar(true));
  }
}

export default onLoadProductData;